import React, { useEffect, useState } from 'react';
import SuperadminLayout from '../../components/SuperadminLayout';
import { fetchAuditLog } from '../../api/auditlog';
import { listCompanies } from '../../api/superadmin';
import './SuperadminAuditLogPage.css';

const ACTOR_TYPES = [
  { value: '', label: 'Tous' },
  { value: 'company', label: 'Company' },
  { value: 'company_user', label: 'Utilisateur company' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'sub_supervisor', label: 'Sub-supervisor' },
  { value: 'bank', label: 'Bank (POS)' },
  { value: 'superadmin', label: 'Superadmin' },
  { value: 'staff', label: 'Staff (limité)' },
];

const ACTIONS = [
  { value: '', label: 'Toutes' },
  { value: 'login', label: 'Login' },
  { value: 'create', label: 'Create' },
  { value: 'update', label: 'Update' },
  { value: 'delete', label: 'Delete' },
];

const fmtVal = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
};

const formatChanges = (changes) => {
  if (!changes) return '—';
  return Object.entries(changes).map(([k, v]) => (
    Array.isArray(v) && v.length === 2
      ? `${k}: ${fmtVal(v[0])} → ${fmtVal(v[1])}`
      : `${k}: ${fmtVal(v)}`
  )).join(', ');
};

const SuperadminAuditLogPage = () => {
  const [rows, setRows] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState('');
  const [actorType, setActorType] = useState('');
  const [action, setAction] = useState('');
  const [modelName, setModelName] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = (params = {}) => {
    setLoading(true);
    setError('');
    fetchAuditLog(params)
      .then(setRows)
      .catch(() => setError('Chargement impossible.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    listCompanies().then(setCompanies).catch(() => {});
  }, []);

  const submit = (e) => {
    e.preventDefault();
    load({ company, actorType, action, modelName, dateFrom, dateTo });
  };

  const reset = () => {
    setCompany(''); setActorType(''); setAction(''); setModelName(''); setDateFrom(''); setDateTo('');
    load();
  };

  return (
    <SuperadminLayout>
      <h2 className="saal-title">Journal d'audit</h2>

      <form className="saal-search" onSubmit={submit}>
        <input
          type="text"
          list="saal-companies-list"
          placeholder="Filtrer par company"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
        />
        <datalist id="saal-companies-list">
          {companies.map((c) => <option key={c.id} value={c.name} />)}
        </datalist>
        <select value={actorType} onChange={(e) => setActorType(e.target.value)}>
          {ACTOR_TYPES.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <select value={action} onChange={(e) => setAction(e.target.value)}>
          {ACTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <input
          type="text"
          placeholder="Modele (ex: Bank)"
          value={modelName}
          onChange={(e) => setModelName(e.target.value)}
        />
        <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
        <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
        <button type="submit" disabled={loading}>{loading ? '…' : 'Filtrer'}</button>
        <button type="button" onClick={reset}>Tout</button>
      </form>

      {error && <p className="saal-error">{error}</p>}

      <table className="saal-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Company</th>
            <th>Acteur</th>
            <th>Action</th>
            <th>Modèle</th>
            <th>Objet</th>
            <th>Détail</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && !loading && (
            <tr><td colSpan="7" className="saal-empty">Aucune entrée.</td></tr>
          )}
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{new Date(r.created_at).toLocaleString()}</td>
              <td>{r.company_name || '—'}</td>
              <td>
                <span className="saal-actor-type">{r.actor_type}</span>
                {' '}{r.actor_label}
              </td>
              <td>{r.action}</td>
              <td>{r.model_name || '—'}</td>
              <td>{r.object_repr || (r.object_id ?? '—')}</td>
              <td className="saal-changes">{formatChanges(r.changes)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </SuperadminLayout>
  );
};

export default SuperadminAuditLogPage;
